import type { INoticeResult } from '@core/databus/IDataSyncManager'
import { NoticeOperationResult } from '@core/databus/IDataSyncManager'
import { INSTANCE as authorTokenManager } from '@core/AuthorTokenManager'

const INDEX_TIMESTAMP_IN_IDENTIFY_STRING_START = 0
const INDEX_TIMESTAMP_IN_IDENTIFY_STRING_END = 13
const FIRST_ATTEMPT = 1

export function composeSuccessData<T>(data?: T): INoticeResult<T> {
  return {
    status: NoticeOperationResult.SUCCESS,
    errNotice: 'Handle a successful!',
    data,
  }
}

export function composeFailedData<T>(errNotice: string, data?: T): INoticeResult<T> {
  return {
    status: NoticeOperationResult.FAILED,
    errNotice,
    data,
  }
}

export function composeErrorData<T>(errNotice: string, data?: T): INoticeResult<T> {
  return {
    status: NoticeOperationResult.ERROR,
    errNotice,
    data,
  }
}

export function composeTimeoutData<T>(data?: T): INoticeResult<T> {
  return {
    status: NoticeOperationResult.TIMEOUT,
    errNotice: 'syncData timeout',
    data,
  }
}

export function getTimestamp(id: string): number {
  return Number.parseInt(id.slice(INDEX_TIMESTAMP_IN_IDENTIFY_STRING_START, INDEX_TIMESTAMP_IN_IDENTIFY_STRING_END))
}

export const retryInterceptor = async (attempt: number, args: unknown[]) => {
  if (attempt > FIRST_ATTEMPT || authorTokenManager.isExpired()) {
    await authorTokenManager.syncRefresh()
  }

  return args
}
